import React, { useEffect } from 'react';
import './Core.css';

// Importing images
import Icon1 from '../Assets/core2.jpeg';
import Icon2 from '../Assets/core3.jpeg';
import Icon3 from '../Assets/core4.jpeg';
import Icon4 from '../Assets/core5.jpeg';
import Icon5 from '../Assets/som.jpg'; // System on Module
import Icon6 from '../Assets/open cpu.jpg'; // Placeholder for Open CPU

const Core = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <div className="Core">
      {/* Hero Section */}
      <div className="hero animate-on-scroll">
        <div className="hero-overlay">
          <h1>Core Technologies That Define Excellence</h1>
          <p>
            Core technology in IoT encompasses the essential components like microcontrollers, sensors, communication protocols, embedded systems, and secure data management that enable smart, interconnected devices to function seamlessly.
          </p>
        </div>
      </div>

      {/* Features Section */}
      <div className="features">
        <div className="feature animate-on-scroll">
          <img src={Icon1} alt="Micro Controller" className="feature-icon" />
          <h3>MicroController</h3>
          <p>
            A microcontroller is a small, integrated computer on a single chip designed to perform specific control tasks in embedded systems.
          </p>
        </div>
        <div className="feature animate-on-scroll">
          <img src={Icon2} alt="Micro Processor" className="feature-icon" />
          <h3>MicroProcessor</h3>
          <p>
            A microprocessor is a central processing unit (CPU) on a single chip that performs general-purpose computing tasks.
          </p>
        </div>
        <div className="feature animate-on-scroll">
          <img src={Icon3} alt="System On Chip" className="feature-icon" />
          <h3>System On Chip</h3>
          <p>
            A System on Chip (SoC) is an integrated circuit that combines a CPU, memory, and peripheral components on a single chip to perform all functions of a complete system.
          </p>
        </div>
        <div className="feature animate-on-scroll">
          <img src={Icon4} alt="Real Time Operating" className="feature-icon" />
          <h3>Real Time Operating</h3>
          <p>
            A real-time operating system (RTOS) is an OS designed to manage hardware resources and execute tasks within a strict time constraint, ensuring timely and predictable responses.
          </p>
        </div>
        <div className="feature animate-on-scroll">
          <img src={Icon5} alt="System On Module" className="feature-icon" />
          <h3>System On Module</h3>
          <p>
            A System on Module (SoM) is a compact, pre-integrated module combining a processor, memory, and other components, designed to simplify embedded system development.
          </p>
        </div>
        <div className="feature animate-on-scroll">
          <img src={Icon6} alt="Open CPU" className="feature-icon" />
          <h3>Open CPU</h3>
          <p>
            An Open CPU is a microcontroller or processor architecture that allows developers to directly access and program the core, enabling flexible and customized IoT solutions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Core;